import React from "react";
import FolderImage from "../assets/images/folder.png";
import { ButtonBase, Typography } from "@material-ui/core";

function FolderView(props) {
  return (
    <ButtonBase
      style={{ display: "flex", flexDirection: "column", alignItems: "center", padding: 16 }}
      onClick={() => {
        if (props.onClick) {
          props.onClick();
        }
      }}
    >
      <div style={{ width: 70, height: 70 }}>
        <img src={FolderImage} alt="Directory" style={{ width: "100%", height: "100%" }} />
      </div>
      <div>
        <Typography>{props.folder.name.split("/")[1]}</Typography>
      </div>
    </ButtonBase>
  );
}

export default FolderView;
